import { get, post } from '@/lib/api/client'
import {
  PaginationParamsSchema,
  MemberFilterParamsSchema,
  type Member,
  type MemberDetail,
  type MemberFilterParams,
  type ApiResponse,
  type PaginatedResponse,
  type PaginationParams
} from '@/lib/api/types'

export class MemberService {
  /**
   * Filter members with pagination (Public endpoint)
   * POST /members/public/filter?page={page}&size={size}
   */
  async getMembers(
    params: PaginationParams = { page: 1, size: 10 },
    filters: MemberFilterParams = {}
  ): Promise<ApiResponse<PaginatedResponse<Member>>> {
    const validatedParams = PaginationParamsSchema.parse(params)
    const validatedFilters = MemberFilterParamsSchema.parse(filters)

    const query = new URLSearchParams({
      page: validatedParams.page.toString(),
      size: validatedParams.size.toString()
    }).toString()

    return await post<ApiResponse<PaginatedResponse<Member>>>(
      `members/public/filter?${query}`,
      validatedFilters
    )
  }

  /**
   * Get member by ID (Public endpoint)
   * GET /members/public/{memberId}
   */
  async getMemberById(memberId: string): Promise<ApiResponse<MemberDetail>> {
    return await get<ApiResponse<MemberDetail>>(
      `members/public/${memberId}`
    )
  }
}

export const memberService = new MemberService()

